import React from 'react';
import { Button } from "primereact/button";
import { useTranslation } from 'react-i18next';

const ProceedButton = ({ loading, disabled, onClick, step }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "0",
        right: "0",
        padding: "0 16px",
      }}
    >
      <Button
        label={`${t("common.proceed")} (${step}/7)`}
        className="btn-primary w-100"
        loading={loading}
        disabled={disabled}
        onClick={onClick}
        size="large"
      />
    </div>
  );
};

export default ProceedButton; 